import { IUser } from "modules/user/types/entities";

import step1Img from "modules/core/assets/img/onboarding/viewer-step-1.png";
import step2Img from "modules/core/assets/img/onboarding/viewer-step-2.png";
import step3Img from "modules/core/assets/img/onboarding/viewer-step-3.png";
import step4Img from "modules/core/assets/img/onboarding/viewer-step-4.png";
import step5Img from "modules/core/assets/img/onboarding/viewer-step-5.png";

export const getSteps = (user?: IUser) => [
  {
    title: `Hey ${user?.name.split(" ")?.at(0) || "There"},`,
    status: "account being created...",
    sideContent: <img src={step1Img} width={200} />
  },
  {
    title: "Your workspace summary",
    status: "preparing your workspace...",
    sideContent: <img src={step2Img} width={260} />
  },
  {
    title: "End-to-end workflow completely centralised",
    status: "optimising your workflows...",
    sideContent: <img src={step3Img} width={300} />
  },
  {
    title: "What's possible with your role?",
    status: "setting up your permissions...",
    sideContent: <img src={step4Img} width={350} />
  },
  {
    title: "Now, let's see what's happened before you joined",
    sideContent: <img src={step5Img} width={350} />
  }
];
